import { render, staticRenderFns } from "./ProfileDropDown.vue?vue&type=template&id=164cb2a8&scoped=true&"
import script from "./ProfileDropDown.vue?vue&type=script&lang=js&"
export * from "./ProfileDropDown.vue?vue&type=script&lang=js&"
import style0 from "./ProfileDropDown.vue?vue&type=style&index=0&id=164cb2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164cb2a8",
  null
  
)

export default component.exports